/**
 * Server-Sent Events, read from a `fetch` body.
 *
 * Not `EventSource`: it cannot send an `Authorization` header, and every
 * Trinity API call carries a bearer token. Reading the body ourselves keeps
 * the token in a header (never in a URL, where it would land in proxy logs)
 * and lets the caller resume with `Last-Event-ID`.
 */
/** Yield each frame as it completes. Comment lines (`: ping`) are skipped. */
export async function* readSse(body) {
    const reader = body.pipeThrough(new TextDecoderStream()).getReader();
    let buffer = '';
    try {
        for (;;) {
            const { value, done } = await reader.read();
            if (done)
                return;
            buffer += value;
            // A frame ends at a blank line; \r\n and \r are legal line endings too.
            buffer = buffer.replace(/\r\n?/g, '\n');
            let end = buffer.indexOf('\n\n');
            while (end >= 0) {
                const frame = parseFrame(buffer.slice(0, end));
                buffer = buffer.slice(end + 2);
                if (frame)
                    yield frame;
                end = buffer.indexOf('\n\n');
            }
        }
    }
    finally {
        reader.releaseLock();
    }
}
function parseFrame(text) {
    let id;
    let event = 'message';
    const data = [];
    for (const line of text.split('\n')) {
        if (!line || line.startsWith(':'))
            continue;
        const colon = line.indexOf(':');
        const field = colon < 0 ? line : line.slice(0, colon);
        const value = colon < 0 ? '' : line.slice(colon + 1).replace(/^ /, '');
        if (field === 'id')
            id = value;
        else if (field === 'event')
            event = value;
        else if (field === 'data')
            data.push(value);
    }
    return data.length ? { id, event, data: data.join('\n') } : null;
}
